import { render, staticRenderFns } from "./growup-tpl.vue?vue&type=template&id=feb1dba0&scoped=true&"
import script from "./growup-tpl.vue?vue&type=script&lang=js&"
export * from "./growup-tpl.vue?vue&type=script&lang=js&"
import style0 from "./growup-tpl.vue?vue&type=style&index=0&id=feb1dba0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb1dba0",
  null
  
)

export default component.exports